import { useEffect, useState } from "react";
import { variables } from "../Variables/Variable";
import { useNavigate } from "react-router-dom";
import Logo from "../Images/homedepot.png";
import { toast } from "react-toastify";
import VR from "../../src/Images/VR.jpg";
import "./layout.css";

const Header = () => {
    const navigate = useNavigate();
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false); // 🔥 Mobile menu state
    const [searchTerm, setSearchTerm] = useState("");
    const [menu, setMenu] = useState([]);
    const [emailNewsLetter, setEmailNewsLetter] = useState("");

    const emailregx =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    function isValid() {
        if (emailNewsLetter === "") {
            toast.error("please Provide your Email");
            return false;
        } else if (!emailregx.test(emailNewsLetter)) {
            toast.error("Bad email format");
            return false;
        }
        return true;
    }

    const HandleSubmit = (e) => {
        e.preventDefault();
        if (isValid()) {
            fetch(variables.API_URL + "NewsLetter/SubscribeToNewsLetter", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": variables.API_URL,
                },
                body: JSON.stringify({
                    Email: emailNewsLetter,
                }),
            }).then((response) => {
                if (response.ok) {
                    toast.success("Subscribed Successfully");
                    setEmailNewsLetter("");
                    return response.json();
                }
                return response.text().then((text) => {
                    throw new Error(text);
                });
            });
        }
    };

    const getMenu = () => {
        fetch(variables.API_URL + "Menu/GetParentMenuesWithSub", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((result) => {
                setMenu(result);
            });
    };

    useEffect(() => {
        getMenu();
    }, []);

    useEffect(() => {
        if (!isSearchOpen) setSearchTerm("");
    }, [isSearchOpen]);

    return (
        <>
            {/* ================= HEADER ================= */}
            <header className="main-header main-header--one main-header--one--two clearfix">
                <div className="main-header--one__wrapper">
                    <div className="auto-container">
                        <div className="main-header--one__inner">
                            {/* Logo */}
                            <div className="main-header--one__left">
                                <div className="logo">
                                    <a hreflang="en" href="/">
                                        <img src={Logo} alt="Home Depot of Lebanon" width="1903" height="539" />
                                    </a>
                                </div>
                            </div>

                            {/* MENU AREA */}
                            <div className="d-flex align-items-center nav-wrapper">
                                <div className="search-icon me-3">
                                    <button
                                        className="mobile-search-toggler-btn"
                                        onClick={() => setIsSearchOpen(true)}
                                        aria-label="Open Search"
                                    >
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>

                                <nav className="main-menu main-menu--1">
                                    <div className="main-menu__inner">
                                        {/* 🔥 MOBILE MENU BUTTON */}
                                        <button
                                            className="mobile-nav__toggler"
                                            onClick={() => setIsMobileNavOpen(true)}
                                        >
                                            <i className="fa fa-bars"></i>
                                        </button>

                                        <div className="stricky-one-logo">
                                            <div className="logo">
                                                <a hreflang="en" href="/">
                                                    <img src={Logo} alt="Home Depot of Lebanon" width="1903" height="539" />
                                                </a>
                                            </div>
                                        </div>

                                        {/* Desktop Menu List */}
                                        <div className="main-header--one__middle">
                                            <ul className="main-menu__list">
                                                {menu.map((menuItem) =>
                                                    menuItem.SubMenus.length === 0 ? (
                                                        <li key={menuItem.MenuId}>
                                                            <a hreflang="en" href={"/" + menuItem.Url}>
                                                                {menuItem.MenuTitle}
                                                            </a>
                                                        </li>
                                                    ) : (
                                                        <li key={menuItem.MenuId} className="dropdown">
                                                            <a>{menuItem.MenuTitle}</a>
                                                            <ul className="ul-subMenu">
                                                                <div className="row" style={{ marginTop: 0 }}>
                                                                    {menuItem.SubMenus.map((subItem) => (
                                                                        <div
                                                                            key={subItem.MenuId}
                                                                            className="col-lg-6 d-flex align-items-center"
                                                                        >
                                                                            <li>
                                                                                <a
                                                                                    hreflang="en" href={
                                                                                        "/" +
                                                                                        subItem.MenuTitle +
                                                                                        "/" +
                                                                                        subItem.MenuId
                                                                                    }
                                                                                >
                                                                                    {subItem.MenuTitle}
                                                                                </a>
                                                                            </li>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </ul>
                                                        </li>
                                                    )
                                                )}

                                                <li key="VR">
                                                    <a hreflang="en" href="/VR">
                                                        <img
                                                            src={VR}
                                                            alt="VR"
                                                            style={{ width: "70px", height: "50px" }}
                                                        />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                            {/* RIGHT SIDE */}
                            <div className="main-header--one__right clearfix">
                                <div className="number">
                                    <a hreflang="en" href="tel:+9611558517">
                                        + 961 1 558517/8 – 554546
                                    </a>
                                </div>

                                <div className="social-icon">
                                    <ul>
                                        <li>
                                            <a
                                                hreflang="en" href="https://www.facebook.com/homedepotlebanon"
                                                target="_blank"
                                            >
                                                <span className="fab fa-facebook"></span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                hreflang="en" href="https://www.linkedin.com/company/home-depot-of-lebanon"
                                                target="_blank"
                                            >
                                                <span className="fab fa-linkedin"></span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                hreflang="en" href="https://www.instagram.com/homedepotoflebanon/?hl=en"
                                                target="_blank"
                                            >
                                                <span className="fab fa-instagram"></span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="search-icon">
                                    <button
                                        className="search-toggler-btn"
                                        onClick={() => setIsSearchOpen(true)}
                                        aria-label="Open Search"
                                    >
                                        <i className="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* ==================== MOBILE MENU ===================== */}
            <div className={`mobile-nav__wrapper ${isMobileNavOpen ? "expanded" : ""}`}>
                {/* 🔥 CLICK OUTSIDE TO CLOSE */}
                <div
                    className="mobile-nav__overlay"
                    onClick={() => setIsMobileNavOpen(false)}
                ></div>

                <div className="mobile-nav__content">
                    {/* 🔥 CLOSE BUTTON */}
                    <span
                        className="mobile-nav__close"
                        onClick={() => setIsMobileNavOpen(false)}
                    >
                        <i className="fa fa-times"></i>
                    </span>

                    <div className="logo-box">
                        <a hreflang="en" href="/" aria-label="logo image">
                            <img src={Logo} width="155" alt="" />
                        </a>
                    </div>

                    {/* MOBILE MENU ITEMS */}
                    <div className="mobile-nav__container_right">
                        <ul className="main-menu__list">
                            {menu.map((menuItem) =>
                                menuItem.SubMenus.length === 0 ? (
                                    <li key={menuItem.MenuId}>
                                        <a
                                            className="cursor-pointer mobile_navitem_hover"
                                            hreflang="en" href={"/" + menuItem.Url}
                                            style={{ color: "black" }}
                                        >
                                            {menuItem.MenuTitle}
                                        </a>
                                    </li>
                                ) : (
                                    <li key={menuItem.MenuId} className="dropdown">
                                        <span className="cursor-pointer mobile_navitem_hover">
                                            {menuItem.MenuTitle}
                                        </span>

                                        <ul className="ul-subMenu">
                                            {menuItem.SubMenus.map((subItem) => (
                                                <li key={subItem.MenuId}>
                                                    <a
                                                        className="cursor-pointer mobile_navitem_hover"
                                                        hreflang="en" href={
                                                            "/" +
                                                            subItem.MenuTitle +
                                                            "/" +
                                                            subItem.MenuId
                                                        }
                                                        style={{ color: "black" }}
                                                    >
                                                        {subItem.MenuTitle}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                )
                            )}

                            <li key="VR">
                                <a className="cursor-pointer" hreflang="en" href="/VR">
                                    <img
                                        src={VR}
                                        style={{ width: "70px", height: "50px" }}
                                        alt=""
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* =================== SEARCH POPUP =================== */}
            {isSearchOpen && (
                <div className="search-popup active">
                    <div
                        className="search-popup__overlay"
                        onClick={() => setIsSearchOpen(false)}
                    ></div>

                    <div className="search-popup__content">
                        <button
                            className="search-close-btn"
                            onClick={() => setIsSearchOpen(false)}
                        >
                            <i className="fa fa-times"></i>
                        </button>

                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                if (searchTerm.trim() !== "") {
                                    setIsSearchOpen(false);
                                    navigate(
                                        `/Content/${encodeURIComponent(searchTerm.trim())}`
                                    );
                                } else {
                                    toast.warning("Please enter a keyword to search");
                                }
                            }}
                            className="search-form"
                        >
                            <div className="search-input-wrapper">
                                <input
                                    type="text"
                                    placeholder="Type something to search..."
                                    className="search-input"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />

                                <button type="submit" className="search-submit-btn">
                                    <i className="fa fa-search"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <a
                hreflang="en" href="#"
                data-target="html"
                className="scroll-to-target scroll-to-top"
            >
                <i className="icon-next"></i>
            </a>
        </>
    );
};

export default Header;
